import FouGrid from 'src/components/layout/fou-grid/'
import FouGroup from 'src/components/layout/fou-group/'
import {mapActions, mapGetters} from 'vuex'
import BulkMetadataUploader from 'src/pages/bulk-import/uploader'
import BulkImportStatus from 'src/pages/bulk-import/importStatus'

export default {
  name: 'bulk-import',

  components: {
    ...FouGrid,
    FouGroup,
    BulkMetadataUploader,
    BulkImportStatus
  },

  methods: {
    ...mapActions('bulkImport', ['reset'])
  },

  computed: {
    ...mapGetters('bulkImport', {
      'getResult': ['getResult'],
      'hasPosted': ['hasPosted'],
      'getFilename': ['getFilename'],
      'showBulkImportStatus': ['showBulkImportStatus']
    })
  }
}
